document.addEventListener("DOMContentLoaded", function () {
    const sectionScopingClassName = "compare-desks-section";
    const selectedClassName = "selected";
  
    const colorSwatches = document.querySelectorAll(
      `.${sectionScopingClassName} .color-swatch`
    );

    colorSwatchClickHandler = (e) => {
      const clickedColorContainer = e.target.parentElement;
      const clickedHandle = e.target.parentElement.dataset["handle"]; // Represent which product card click was on.
      const clickedVariantId = clickedColorContainer.dataset["variantId"]; // Represents which variant the click was on.
  
      const curSelectedImageContainer = document.querySelector(
        `.${sectionScopingClassName} .product-mini-card[data-handle="${clickedHandle}"] .product-image-container.${selectedClassName}`
      );
      curSelectedImageContainer.classList.remove(selectedClassName);
      const curSelectedColorContainer = document.querySelector(
        `.${sectionScopingClassName} .product-mini-card[data-handle="${clickedHandle}"] .color-container.${selectedClassName}`
      );
      curSelectedColorContainer.classList.remove(selectedClassName);
  
      const clickedProductImageContainer = document.querySelector(
        `.${sectionScopingClassName} .product-image-container[data-variant-id="${clickedVariantId}"]`
      );
      clickedProductImageContainer.classList.add(selectedClassName);
      clickedColorContainer.classList.add(selectedClassName);
    };
  
    /** Attach event listeners to all color swatches. */
    colorSwatches.forEach((swatch) => {
      swatch.addEventListener("click", colorSwatchClickHandler);
    }); 
  });
  